import React, { useEffect, useState } from 'react'
import NewInvoicePopup from './NewInvoicePopup';
import Validator, { ValidationTypes as V_Type } from "react-form-supervalidator";
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';
import Show from 'Components/Show/Show';
import PaymentPortalStatementDetails from './PaymentPortalStatementDetails';
import { useSearchParams } from 'react-router-dom';
import PaymentPortalForm from 'Pages/PaymentPortal/PaymentPortalForm';
import { InvalidDateValidator } from 'Utils/validators';
import axios from 'axios';
import GuestPaymentPortalForm from './GuestPaymentPortalForm';

const initialAuthModel = {
    isPatientAuthenticated: false,
    message: "",
    errorType: null,
    patient: {
        patientId: null,
        practiceId: null,
        accountNumber: "",
        patientBirthday: "",
        expiredDate: null,
        hasPaidAlready: false,
        invoiceNumber: "",
        invoiceUrl: "",
        isCancelled: false,
        isExpired: false,
        newInvoiceNumber: "",
        paidAmount: 0,
        paidOnDate: null,
        paymentMainId: 0,
        providerId: null
    },
    isError: false,
    responseMessage: "",
    statusCode: null
};
const PaymentPortal = () => {
    const [model, setModel] = useState({
        loginModel: {
            "patientId": 0,
            "practiceId": 0,
            "accountNumber": "",
            "patientBirthday": "",
            "invoiceNumber": "",
            "paymentMainId": 0,
            "providerId": 0,
            "isReCaptchaPassed": false
        },
        loader: false,
        isNewInvoice: null,
    })
    const [activeForm, setActiveForm] = useState("paymentPortalForm")
    const [validationModel, setValidationModel] = useState({
        invoiceNumberError: null,
        dateOfBirthError: null,
    });
    const [date, setDate] = useState({
        day:'',
        month:'',
        year:''
    })
    const [authResponse, setAuthResponse] = useState(initialAuthModel);
    const [viewDetails, setViewDetails] = useState(false)

    const [searchParams] = useSearchParams();


    const setValidation = () => {
        let myValidationObj = {
            ...validationModel,
            invoiceNumberError: Validator(model.loginModel.invoiceNumber, [V_Type.required], ['Invoice Number is required']),
            dateOfBirthError: activeForm === "paymentPortalForm"
                ? Validator(
                    model.loginModel.patientBirthday,
                    [V_Type.required, InvalidDateValidator],
                    ['Date of Birth is required', 'Date of Birth is invalid']
                )
                : null, // or keep existing value if needed: validationModel.dateOfBirthError
        };
        setValidationModel(myValidationObj);
        return Validator(myValidationObj, V_Type.NullCheck);
    };
    const handleChange = (e) => {
        const { name, value } = e.target
        setModel((prev) => ({
            ...prev,
            loginModel: { ...prev.loginModel, [name]: value.trim() }

        }))
    }
    const handleActiveForm=(formName) => {
        setActiveForm(formName)
        setValidationModel({
            invoiceNumberError: null,
            dateOfBirthError: null, // Reset date of birth error when switching forms
        });
    };  
    const handleChangeMobile = (e, type) => {
        let { value } = e.target;

        // allow only numbers
        value = value.replace(/\D/g, "");

        // limit length depending on field
        if (type === "day" || type === "month") {
            if (value.length > 2) value = value.slice(0, 2);
        } else if (type === "year") {
            if (value.length > 4) value = value.slice(0, 4);
        }

        // build the next state before setting
        const nextDate = { ...date, [type]: value };
        const patientBirthday =
            !nextDate.year && !nextDate.month && !nextDate.day
                ? ""
                : `${nextDate.year}-${String(nextDate.month).padStart(2, "0")}-${String(nextDate.day).padStart(2, "0")}`;    
        setDate(nextDate);
        setModel((prev) => ({
            ...prev,
            loginModel: {
                ...prev.loginModel,
                patientBirthday: patientBirthday
            }
        }));
    };


    const handleCancelNewInvoice = () => {
        setModel(prev => ({ ...prev, isNewInvoice: null }));
    };
    const isPPRInvoice = (inv) => {
        return typeof inv === 'string' && inv.includes('PPR');
    };
    const authorizePatient = async () => {
        let myValidation = setValidation();
        if (!myValidation) {
            const { invoiceNumber, patientBirthday } = model.loginModel
            if (invoiceNumber && patientBirthday) {
                try {
                    setModel((prev) => ({ ...prev, loader: true }))
                    const pprInvoice = isPPRInvoice(invoiceNumber)
                    if (pprInvoice) {
                        const authRes = await axios.post(
                            `${process.env.REACT_APP_TC_PMS}/api/StripeApi/AuthorizePatientPaymentRequestGateway`,
                            model.loginModel
                        );
                        const payload = {
                            ...authRes.data.dataModel.patient,
                            isReCaptchaPassed: true,
                            invoiceNumber: model.loginModel.invoiceNumber
                        }
                        const res = await axios.post(
                            `${process.env.REACT_APP_TC_PMS}/api/StripeApi/CreateRequestedCheckOutSessionOnline`,
                            payload
                        );               
                        window.location.href = res.data.dataModel.checkoutUrl
                    } else {
                        const authRes = await axios.post(
                            `${process.env.REACT_APP_TC_PMS}/api/StripeApi/AuthorizePatientGateway`,
                            model.loginModel
                        );                    
                        setAuthResponse(authRes.data.dataModel);
                        setViewDetails(true)
                    }
                } catch (error) {
                    if (!error.response.data.dataModel?.isPatientAuthenticated && error.response.data.dataModel?.patient?.newInvoiceNumber) {
                        setModel(prev => ({ ...prev, isNewInvoice: { patient: error.response.data.dataModel.patient, message: error.response.data.responseMessage } }))
                    }
                    ErrorHandlingMessage(error)
                } finally {
                    setModel((prev) => ({ ...prev, loader: false }))
                }
            }
        }
    }
    const handleViewPayment = async () => {
        let myValidation = setValidation();
        if (!myValidation) {
        try {
            setModel((prev) => ({ ...prev, loader: true }))
            const endPoint = isPPRInvoice(model.loginModel.invoiceNumber)
                ? "AuthorizeGuestPaymentRequestGateway"
                : "AuthorizeGuestPatientGateway";
            const response = await axios.post(`${process.env.REACT_APP_TC_PMS}/api/StripeApi/${endPoint}`, {
                invoiceNumber: model.loginModel.invoiceNumber
            });
            setAuthResponse(response.data.dataModel);
            await handleAuthenticate(response.data.dataModel);
        } catch (error) {
            ErrorHandlingMessage(error);
        } finally {
            setModel((prev) => ({ ...prev, loader: false }))
        }
    }
    };
    const handleAuthenticate = async (data) => {
        try {
            setModel((prev) => ({ ...prev, loader: true }))
            const pprInvoice = isPPRInvoice(model.loginModel.invoiceNumber)
            const endPoint = pprInvoice
                ? "CreateRequestedCheckOutSessionOnline"
                : "CreateCheckOutSessionOnline";
            const res = await axios.post(`${process.env.REACT_APP_TC_PMS}/api/StripeApi/${endPoint}`, {
                ...data.patient,
                isReCaptchaPassed: true,
                patientBirthday: "",
                invoiceNumber: data.patient.invoiceNumber
            });
            const url = pprInvoice ? res.data.dataModel.checkoutUrl : res.data.dataModel.url;
            window.location.href = url;
        } catch (error) {
            ErrorHandlingMessage(error);
        } finally {
            setModel((prev) => ({ ...prev, loader: false }))
        }
    };
    useEffect(() => {
        const invoiceNumber = searchParams.get("INV")
        if (invoiceNumber) {
            setModel((prev) => ({
                ...prev,
                loginModel: {
                    ...prev.loginModel,
                    invoiceNumber: invoiceNumber
                }
            }))
        }
    }, [searchParams])
    return (
        <>
            {model.isNewInvoice && <NewInvoicePopup onCancel={handleCancelNewInvoice} patientData={model.isNewInvoice} />}
            <Show when={!viewDetails} fallback={<PaymentPortalStatementDetails handleAuthenticate={handleAuthenticate} model={model} authResponse={authResponse} />}>
                <Show when={activeForm === "paymentPortalForm"}
                    fallback={<GuestPaymentPortalForm
                    model={model}
                    handleChange={handleChange}
                    validationModel={validationModel}
                    handleActiveForm={handleActiveForm}
                    authorizePatient={handleViewPayment}
                />}>
                    <PaymentPortalForm
                        model={model}
                        handleChange={handleChange}
                        validationModel={validationModel}
                        date={date}
                        handleActiveForm={handleActiveForm}
                        handleChangeMobile={handleChangeMobile}
                        authorizePatient={authorizePatient}
                    />
            </Show>
            </Show>
        </>
    )
}

export default PaymentPortal